<template>
    <div class="d-flex flex-column">
        <AsyncWrapper :data="results" :loading="async.loading" :error="async.error" :wrapperClass="'flex-grow'">
            <template slot="dataComponent">
                <account-view :user="results"></account-view>
            </template>
            <template slot="loadingComponent">
                <i class="fa fa-circle-o-notch fa-2x fa-spin"></i>
            </template>
            <template slot="errorComponent">
                <p>{{ async.error }}</p>
            </template>
        </AsyncWrapper>
    </div>
</template>
<script>
import AccountView from './AccountView'
export default {
    components: {
        AccountView
    },
    computed: {
        results() {
            return this.$store.getters['usersSupport/GET_USER_SUPPORT']
        },
        async() {
            return this.$store.getters['usersSupport/GET_ASYNC']
        }
    },
    created() {
        this.$store.dispatch('usersSupport/FETCH_USER_SUPPORT_BY_ID', {
            id: this.$store.getters['auth/GET_CURRENT_USER'].uid
        })
    },
    async beforeDestroy() {
        await this.$store.dispatch('usersSupport/REMOVE_USER_SUPPORT_REFERENCE', {
            id: this.$store.getters['usersSupport/GET_USER_SUPPORT'].id
        })
    }
}
</script>
